/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'contacts': {
    width: 18,
    height: 20,
    viewBox: '0 0 18 20',
    data: '<defs/><path pid="0" id="contacts" class="cls-1" d="M33 235a2.793 2.793 0 0 1 3-3 2.793 2.793 0 0 1 3 3h-6zm5-6a2 2 0 1 1-2-2 2 2 0 0 1 2 2zm4-8H30a2 2 0 0 0-2 2v2h-2v2h2v3h-2v2h2v3h-2v2h2v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-16a2 2 0 0 0-2-2zm-12 18v-2h1v-2h-1v-3h1v-2h-1v-3h1v-2h-1v-2h12v16H30z" transform="translate(-26 -221)"/>'
  }
})
